/* parser generated by jison 0.4.18 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var parser = (function(){
var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[1,10],$V1=[1,7],$V2=[1,11],$V3=[1,5],$V4=[1,8],$V5=[1,9],$V6=[1,13],$V7=[5,13],$V8=[5,7,8,13],$V9=[1,31],$Va=[5,7,8,13,16,25,27,31,32,33,34,35,36,37,38,39],$Vb=[10,12,17,22],$Vc=[1,40],$Vd=[1,49],$Ve=[1,51],$Vf=[1,50],$Vg=[1,52],$Vh=[1,53],$Vi=[1,54],$Vj=[2,38],$Vk=[7,8],$Vl=[2,39],$Vm=[1,78],$Vn=[13,19,40];
var parser = {trace: function trace () { },
yy: {},
symbols_: {"error":2,"expressions":3,"e":4,"EOF":5,"t":6,"\\\\/":7,"/\\\\":8,"field":9,"IDENT":10,"restr":11,"(":12,")":13,"comp":14,"val":15,"IN":16,"{":17,"vals":18,"}":19,"notin":20,"..":21,"[":22,"]":23,"VAL":24,"IS":25,"classifier_e":26,"NOT":27,"membership":28,"TRUE":29,"FALSE":30,"NOTIN":31,"<":32,">":33,"=":34,"/=":35,">=":36,"<=":37,"~=":38,"~/=":39,",":40,"valsorempty":41,"classifier_t":42,"VERY":43,"SLIGHTLY":44,"CLOSE":45,"TO":46,"$accept":0,"$end":1},
terminals_: {2:"error",5:"EOF",7:"\\\\/",8:"/\\\\",10:"IDENT",12:"(",13:")",16:"IN",17:"{",19:"}",21:"..",22:"[",23:"]",24:"VAL",25:"IS",27:"NOT",29:"TRUE",30:"FALSE",31:"NOTIN",32:"<",33:">",34:"=",35:"/=",36:">=",37:"<=",38:"~=",39:"~/=",40:",",43:"VERY",44:"SLIGHTLY",45:"CLOSE",46:"TO"},
productions_: [0,[3,2],[4,3],[4,3],[4,1],[9,2],[11,0],[11,3],[6,3],[6,5],[6,5],[6,7],[6,7],[6,7],[6,7],[6,7],[6,7],[6,7],[6,7],[6,3],[6,1],[6,2],[6,1],[6,3],[6,1],[6,1],[20,2],[20,1],[14,1],[14,1],[14,1],[14,1],[14,1],[14,1],[14,1],[14,1],[18,1],[18,3],[15,1],[41,0],[41,1],[28,5],[28,5],[26,3],[26,3],[42,1],[42,2],[42,3],[42,2],[42,2],[42,3]],
performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
/* this == yyval */

var $0 = $$.length - 1;
switch (yystate) {
case 1:
 return $$[$0-1]; 
break;
case 2:
this.$ = { op: 'or', f: $$[$0-2], s: $$[$0]};
break;
case 3:
this.$ = { op: 'and', f: $$[$0-2], s: $$[$0]};
break;
case 4: case 22: case 40:
this.$ = $$[$0];
break;
case 5:
 this.$ = { q: $$[$0-1], r: $$[$0] }; 
break;
case 6:
 this.$ = null; 
break;
case 7: case 47:
 this.$ = $$[$0-1]; 
break;
case 8:
this.$ = { comp: $$[$0-1], f: $$[$0-2].q, s: $$[$0], r: $$[$0-2].r };
break;
case 9:
this.$ = { comp: 'in', f: $$[$0-4].q, s: $$[$0-1], r: $$[$0-4].r };
break;
case 10:
this.$ = { comp: 'ex', f: $$[$0-4].q, s: $$[$0-1], r: $$[$0-4].r };
break;
case 11:
this.$ = { comp: 'BTW_NE', f: $$[$0-6].q, s: [$$[$0-3], $$[$0-1]], r: $$[$0-6].r };
break;
case 12:
this.$ = { comp: 'NBTW_NE', f: $$[$0-6].q, s: [$$[$0-3], $$[$0-1]], r: $$[$0-6].r };
break;
case 13:
this.$ = { comp: 'BTW_LE', f: $$[$0-6].q, s: [$$[$0-3], $$[$0-1]], r: $$[$0-6].r };
break;
case 14:
this.$ = { comp: 'NBTW_LE', f: $$[$0-6].q, s: [$$[$0-3], $$[$0-1]], r: $$[$0-6].r };
break;
case 15:
this.$ = { comp: 'BTW_GE', f: $$[$0-6].q, s: [$$[$0-3], $$[$0-1]], r: $$[$0-6].r };
break;
case 16:
this.$ = { comp: 'NBTW_GE', f: $$[$0-6].q, s: [$$[$0-3], $$[$0-1]], r: $$[$0-6].r };
break;
case 17:
this.$ = { comp: 'BTW_E', f: $$[$0-6].q, s: [$$[$0-3], $$[$0-1]], r: $$[$0-6].r };
break;
case 18:
this.$ = { comp: 'NBTW_E', f: $$[$0-6].q, s: [$$[$0-3], $$[$0-1]], r: $$[$0-6].r };
break;
case 19:
this.$ = { comp: 'IS', f: $$[$0-2].q, classifier: $$[$0-1]};
break;
case 20:
this.$ = { comp: 'NOTNULL', f: $$[$0].q, r: $$[$0].r};
break;
case 21:
this.$ = { comp: 'NULL', f: $$[$0].q, r: $$[$0].r};
break;
case 23:
this.$ = $$[$0-1];
break;
case 24:
this.$ = {truth: true};
break;
case 25:
this.$ = {falseness: true};
break;
case 28: case 29: case 30: case 31: case 32: case 33: case 34: case 35:
this.$ = $$[$0]
break;
case 36:
this.$ = [$$[$0]];
break;
case 37:
this.$ = $$[$0-2].concat($$[$0]);
break;
case 38:
this.$ = $$[$0].charAt(0) == '"' ? $$[$0].slice(1, -1) : $$[$0];
break;
case 39:
this.$ = [];
break;
case 41:
this.$ = { m: $$[$0-3], positive: true, arg: $$[$0-1]};
break;
case 42:
this.$ = { m: $$[$0-3], positive: false, arg: $$[$0-1]};
break;
case 43:
 this.$ = { op: 'and', f: $$[$0-2], s: $$[$0]}; 
break;
case 44:
 this.$ = { op: 'or', f: $$[$0-2], s: $$[$0]}; 
break;
case 45:
 this.$ = $$[$0]; 
break;
case 46:
 this.$ = { not: $$[$0]}; 
break;
case 48:
 this.$ = { modifier: 'very', c: $$[$0]}; 
break;
case 49:
 this.$ = { modifier: 'slightly', c: $$[$0]}; 
break;
case 50:
 this.$ = {modifier: 'closeto', val: $$[$0]}; 
break;
}
},
table: [{3:1,4:2,6:3,9:4,10:$V0,12:$V1,16:$V2,20:12,27:$V3,28:6,29:$V4,30:$V5,31:$V6},{1:[3]},{5:[1,14]},o($V7,[2,4],{7:[1,15],8:[1,16]}),o($V8,[2,20],{14:17,20:19,16:[1,18],25:[1,20],27:[1,29],31:$V6,32:[1,21],33:[1,22],34:[1,23],35:[1,24],36:[1,25],37:[1,26],38:[1,27],39:[1,28]}),{9:30,10:$V0,16:$V9},o($V8,[2,22]),{4:32,6:3,9:4,10:$V0,12:$V1,16:$V2,20:12,27:$V3,28:6,29:$V4,30:$V5,31:$V6},o($V8,[2,24]),o($V8,[2,25]),o($Va,[2,6],{11:33,12:[1,34]}),{10:[1,35]},{10:[1,36]},o($Vb,[2,27]),{1:[2,1]},{4:37,6:3,9:4,10:$V0,12:$V1,16:$V2,20:12,27:$V3,28:6,29:$V4,30:$V5,31:$V6},{4:38,6:3,9:4,10:$V0,12:$V1,16:$V2,20:12,27:$V3,28:6,29:$V4,30:$V5,31:$V6},{15:39,24:$Vc},{12:[1,42],17:[1,41],22:[1,43]},{12:[1,45],17:[1,44],22:[1,46]},{10:$Vd,12:$Ve,26:47,27:$Vf,42:48,43:$Vg,44:$Vh,45:$Vi},{24:[2,28]},{24:[2,29]},{24:[2,30]},{24:[2,31]},{24:[2,32]},{24:[2,33]},{24:[2,34]},{24:[2,35]},{16:$V9},o($V8,[2,21]),o($Vb,[2,26]),{13:[1,55]},o($Va,[2,5]),{4:56,6:3,9:4,10:$V0,12:$V1,16:$V2,20:12,27:$V3,28:6,29:$V4,30:$V5,31:$V6},{12:[1,57]},{12:[1,58]},o($V7,[2,2]),o($V7,[2,3]),o($V8,[2,8]),o([5,7,8,13,19,21,23,40],$Vj),{15:60,18:59,24:$Vc},{15:61,24:$Vc},{15:62,24:$Vc},{15:60,18:63,24:$Vc},{15:64,24:$Vc},{15:65,24:$Vc},o($V8,[2,19]),{7:[1,67],8:[1,66]},o($Vk,[2,45]),{10:$Vd,12:$Ve,26:68,27:$Vf,42:48,43:$Vg,44:$Vh,45:$Vi},{10:$Vd,12:$Ve,26:69,27:$Vf,42:48,43:$Vg,44:$Vh,45:$Vi},{10:$Vd,12:$Ve,26:70,27:$Vf,42:48,43:$Vg,44:$Vh,45:$Vi},{10:$Vd,12:$Ve,26:71,27:$Vf,42:48,43:$Vg,44:$Vh,45:$Vi},{46:[1,72]},o($V8,[2,23]),{13:[1,73]},{13:$Vl,15:60,18:75,24:$Vc,41:74},{13:$Vl,15:60,18:75,24:$Vc,41:76},{19:[1,77],40:$Vm},o($Vn,[2,36]),{21:[1,79]},{21:[1,80]},{19:[1,81],40:$Vm},{21:[1,82]},{21:[1,83]},{10:$Vd,12:$Ve,26:84,27:$Vf,42:48,43:$Vg,44:$Vh,45:$Vi},{10:$Vd,12:$Ve,26:85,27:$Vf,42:48,43:$Vg,44:$Vh,45:$Vi},o($Vk,[2,46]),{13:[1,86]},o($Vk,[2,48]),o($Vk,[2,49]),{15:87,24:$Vc},o($Va,[2,7]),{13:[1,88]},{13:[2,40],40:$Vm},{13:[1,89]},o($V8,[2,9]),{15:90,24:$Vc},{15:91,24:$Vc},{15:92,24:$Vc},o($V8,[2,10]),{15:93,24:$Vc},{15:94,24:[1,95]},o($V8,[2,43]),o($V8,[2,44]),o($Vk,[2,47]),o($Vk,[2,50]),o($V8,[2,41]),o($V8,[2,42]),o($Vn,[2,37]),{13:[1,96],23:[1,97]},{13:[1,98],23:[1,99]},{13:[1,100],23:[1,101]},{13:[1,102]},{13:$Vj,23:[1,103]},o($V8,[2,11]),o($V8,[2,15]),o($V8,[2,13]),o($V8,[2,17]),o($V8,[2,12]),o($V8,[2,16]),o($V8,[2,14]),o($V8,[2,18])],
defaultActions: {14:[2,1],21:[2,28],22:[2,29],23:[2,30],24:[2,31],25:[2,32],26:[2,33],27:[2,34],28:[2,35]},
parseError: function parseError (str, hash) {
    if (hash.recoverable) {
        this.trace(str);
    } else {
        var error = new Error(str);
        error.hash = hash;
        throw error;
    }
},
parse: function parse(input) {
    var self = this, stack = [0], tstack = [], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
    var args = lstack.slice.call(arguments, 1);
    var lexer = Object.create(this.lexer);
    var sharedState = { yy: {} };
    for (var k in this.yy) {
        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
            sharedState.yy[k] = this.yy[k];
        }
    }
    lexer.setInput(input, sharedState.yy);
    sharedState.yy.lexer = lexer;
    sharedState.yy.parser = this;
    if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
    }
    var yyloc = lexer.yylloc;
    lstack.push(yyloc);
    var ranges = lexer.options && lexer.options.ranges;
    if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
    } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
    }
    function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }
    _token_stack:
        var lex = function () {
            var token;
            token = lexer.lex() || EOF;
            if (typeof token !== 'number') {
                token = self.symbols_[token] || token;
            }
            return token;
        };
    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == 'undefined') {
                symbol = lex();
            }
            action = table[state] && table[state][symbol];
        }
                    if (typeof action === 'undefined' || !action.length || !action[0]) {
                var errStr = '';
                expected = [];
                for (p in table[state]) {
                    if (this.terminals_[p] && p > TERROR) {
                        expected.push('\'' + this.terminals_[p] + '\'');
                    }
                }
                if (lexer.showPosition) {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
                } else {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
                }
                this.parseError(errStr, {
                    text: lexer.match,
                    token: this.terminals_[symbol] || symbol,
                    line: lexer.yylineno,
                    loc: yyloc,
                    expected: expected
                });
            }
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
        }
        switch (action[0]) {
        case 1:
            stack.push(symbol);
            vstack.push(lexer.yytext);
            lstack.push(lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
                yyleng = lexer.yyleng;
                yytext = lexer.yytext;
                yylineno = lexer.yylineno;
                yyloc = lexer.yylloc;
                if (recovering > 0) {
                    recovering--;
                }
            } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
            }
            break;
        case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {
                first_line: lstack[lstack.length - (len || 1)].first_line,
                last_line: lstack[lstack.length - 1].last_line,
                first_column: lstack[lstack.length - (len || 1)].first_column,
                last_column: lstack[lstack.length - 1].last_column
            };
            if (ranges) {
                yyval._$.range = [
                    lstack[lstack.length - (len || 1)].range[0],
                    lstack[lstack.length - 1].range[1]
                ];
            }
            r = this.performAction.apply(yyval, [
                yytext,
                yyleng,
                yylineno,
                sharedState.yy,
                action[1],
                vstack,
                lstack
            ].concat(args));
            if (typeof r !== 'undefined') {
                return r;
            }
            if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
        case 3:
            return true;
        }
    }
    return true;
}};
/* generated by jison-lex 0.3.4 */
var lexer = (function(){
var lexer = ({

EOF:1,

parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },

// resets the lexer, sets new input
setInput:function (input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
        };
        if (this.options.ranges) {
            this.yylloc.range = [0,0];
        }
        this.offset = 0;
        return this;
    },

// consumes and returns one char from the input
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) {
            this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
    },

// unshifts one char (or a string) into the input
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;

        this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
              this.yylloc.first_column - len
        };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
    },

// When called from action, caches matched text and appends it on next action
more:function () {
        this._more = true;
        return this;
    },

// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
reject:function () {
        if (this.options.backtrack_lexer) {
            this._backtrack = true;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });

        }
        return this;
    },

// retain first n characters of the match
less:function (n) {
        this.unput(this.match.slice(n));
    },

// displays already matched input, i.e. for error messages
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },

// displays upcoming input, i.e. for error messages
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
    },

// displays the character position where the lexing error occurred, i.e. for error messages
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
    },

// test the lexed token: return FALSE when not a match, otherwise return token
test_match:function(match, indexed_rule) {
        var token,
            lines,
            backup;

        if (this.options.backtrack_lexer) {
            // save context
            backup = {
                yylineno: this.yylineno,
                yylloc: {
                    first_line: this.yylloc.first_line,
                    last_line: this.last_line,
                    first_column: this.yylloc.first_column,
                    last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
            };
            if (this.options.ranges) {
                backup.yylloc.range = this.yylloc.range.slice(0);
            }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno += lines.length;
        }
        this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ?
                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                         this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
            this.done = false;
        }
        if (token) {
            return token;
        } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
                this[k] = backup[k];
            }
            return false; // rule action called reject() implying the next rule should be tested instead.
        }
        return false;
    },

// return next match in input
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) {
            this.done = true;
        }

        var token,
            match,
            tempMatch,
            index;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (this.options.backtrack_lexer) {
                    token = this.test_match(tempMatch, rules[i]);
                    if (token !== false) {
                        return token;
                    } else if (this._backtrack) {
                        match = false;
                        continue; // rule action called reject() implying a rule MISmatch.
                    } else {
                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                        return false;
                    }
                } else if (!this.options.flex) {
                    break;
                }
            }
        }
        if (match) {
            token = this.test_match(match, rules[index]);
            if (token !== false) {
                return token;
            }
            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });
        }
    },

// return next match that has a token
lex:function lex () {
        var r = this.next();
        if (r) {
            return r;
        } else {
            return this.lex();
        }
    },

// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
begin:function begin (condition) {
        this.conditionStack.push(condition);
    },

// pop the previously active lexer condition state off the condition stack
popState:function popState () {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
            return this.conditionStack.pop();
        } else {
            return this.conditionStack[0];
        }
    },

// produce the lexer rule set which is active for the currently active lexer condition state
_currentRules:function _currentRules () {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
            return this.conditions["INITIAL"].rules;
        }
    },

// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
topState:function topState (n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
            return this.conditionStack[n];
        } else {
            return "INITIAL";
        }
    },

// alias for begin(condition)
pushState:function pushState (condition) {
        this.begin(condition);
    },

// return the number of states currently on the stack
stateStackSize:function stateStackSize() {
        return this.conditionStack.length;
    },
options: {},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0:/* skip whitespace */
break;
case 1: yy_.yytext = yy_.yytext.replace('\\"','"').replace('\\n','\n').replace('\\r','\r').replace('\\t','\t'); return "VAL"; 
break;
case 2:return 24
break;
case 3:return 29
break;
case 4:return 30
break;
case 5:return 16
break;
case 6:return 25
break;
case 7:return 45
break;
case 8:return 46
break;
case 9:return 43
break;
case 10:return 44
break;
case 11:return 16
break;
case 12:return 16
break;
case 13:return 27
break;
case 14:return 27
break;
case 15:return 31
break;
case 16:return 10
break;
case 17:return 34
break;
case 18:return 38
break;
case 19:return 38
break;
case 20:return 39
break;
case 21:return 39
break;
case 22:return 35
break;
case 23:return 35
break;
case 24:return 37
break;
case 25:return 37
break;
case 26:return 36
break;
case 27:return 36
break;
case 28:return 32
break;
case 29:return 33
break;
case 30:return 12
break;
case 31:return 13
break;
case 32:return 22
break;
case 33:return 23
break;
case 34:return 17
break;
case 35:return 19
break;
case 36:return 40
break;
case 37:return 21
break;
case 38:return 8
break;
case 39:return 8
break;
case 40:return 8
break;
case 41:return 7
break;
case 42:return 7
break;
case 43:return 7
break;
case 44:return 5
break;
case 45:return 'INVALID'
break;
}
},
rules: [/^(?:\s+)/,/^(?:["]([^"]|\\"|\\n|\\r|\\t)*["])/,/^(?:[0-9]+(\.[0-9]+)?)/,/^(?:true\b)/,/^(?:false\b)/,/^(?:in\b)/,/^(?:is\b)/,/^(?:close\b)/,/^(?:to\b)/,/^(?:very\b)/,/^(?:slightly\b)/,/^(?:\u2208)/,/^(?:\u220a)/,/^(?:not\b)/,/^(?:\u00ac)/,/^(?:\u2209)/,/^(?:[a-zA-Z][0-9a-zA-Z\.]*[0-9a-zA-Z]*)/,/^(?:=)/,/^(?:~=)/,/^(?:\u2287)/,/^(?:~\/=)/,/^(?:\u2288)/,/^(?:\/=)/,/^(?:\u2260)/,/^(?:<=)/,/^(?:\u2264)/,/^(?:>=)/,/^(?:\u2265)/,/^(?:<)/,/^(?:>)/,/^(?:\()/,/^(?:\))/,/^(?:\[)/,/^(?:\])/,/^(?:\{)/,/^(?:\})/,/^(?:,)/,/^(?:\.\.)/,/^(?:\/\\)/,/^(?:\u2227)/,/^(?:\u8896)/,/^(?:\\\/)/,/^(?:\u2228)/,/^(?:\u8897)/,/^(?:$)/,/^(?:.)/],
conditions: {"INITIAL":{"rules":[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45],"inclusive":true}}
});
return lexer;
})();
parser.lexer = lexer;
function Parser () {
  this.yy = {};
}
Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})();


if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
exports.parser = parser;
exports.Parser = parser.Parser;
exports.parse = function () { return parser.parse.apply(parser, arguments); };
exports.main = function commonjsMain (args) {
    if (!args[1]) {
        console.log('Usage: '+args[0]+' FILE');
        process.exit(1);
    }
    var source = require('fs').readFileSync(require('path').normalize(args[1]), "utf8");
    return exports.parser.parse(source);
};
if (typeof module !== 'undefined' && require.main === module) {
  exports.main(process.argv.slice(1));
}
}